<div class="page">
  <div class="header">
    <h1 class="header-title">
      <mat-icon>edit_road</mat-icon>
      <span>Ritvoorbereiding</span>
    </h1>
    @if (selectedTabKey !== 'particularities') {
      <button
        mat-icon-button
        class="export-button"
        aria-label="Importeren en exporteren"
        (click)="openImportExport()"
        [class.spinner]="processing()"
      >
        <mat-icon>import_export</mat-icon>
        <div class="button-text">Importeren/Exporteren</div>
      </button>
    }
  </div>
  <div class="content">
    <mat-tab-group [selectedIndex]="selectedIndex()" (selectedTabChange)="selectedIndex.set($event.index); updateUrl()">
      @for (tab of tabs; track tab.key) {
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>{{ tab.icon }}</mat-icon>
            <span>{{ tab.name }}</span>
          </ng-template>
          @switch (tab.key) {
            @case ('characteristics') {
              <app-characteristics #tab></app-characteristics>
            }
            @case ('standardLocations') {
              <app-standard-locations #tab></app-standard-locations>
            }
            @case ('phoneNumbers') {
              <app-phone-numbers #tab></app-phone-numbers>
            }
            @case ('particularities') {
              <app-particularities #tab></app-particularities>
            }
          }
        </mat-tab>
      }
    </mat-tab-group>
    <input hidden type="file" accept=".xlsx" #uploader (change)="uploadedFile($event)" />
    <button mat-fab extended aria-label="Item toevoegen" (click)="activeTab?.editItem()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <!-- Address validation progress overlay -->
  @if (addressValidationService.isBulkValidating()) {
    <div class="validation-overlay">
      <div class="validation-progress-container" role="status" aria-live="polite" aria-atomic="true">
        <h3>Importeren...</h3>
        <mat-progress-bar mode="determinate" [value]="addressValidationService.bulkProgress()"></mat-progress-bar>
        <p class="progress-text">{{ addressValidationService.bulkProgress() }}% voltooid</p>
      </div>
    </div>
  }
</div>
